var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActive = function SvgActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 10.5,
    x: 0.75,
    y: 0.75,
    stroke: "#3F6DE1",
    strokeWidth: 1.5,
    rx: 3.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 3,
    y: 3,
    fill: "#3F6DE1",
    rx: 2
  })));
};
export default SvgActive;